export default "__VITE_ASSET__dOcn_ChV__"